import {createReducer, on} from '@ngrx/store';
import {BorrowingHistoryRecord, Checkout, CheckoutClaim} from '@store/checkouts/checkouts.types';
import {CheckoutsActions} from '@store/checkouts/checkouts.actions';
import {INITIAL_LOAD_STATUS_SUBSTATE, LoadStatusSubstate} from '@aviary/store/store.types';
import {DateOnlyIsoString, FAILED, LOADED, LOADING} from '@aviary/store/common/common.types';
import {PatronActions} from '@store/patron/patron.actions';

export interface CheckoutsState {
  checkedOut: LoadStatusSubstate & {
    data: Checkout[];
  };
  nextCheckedOutDueDate: LoadStatusSubstate & {
    date?: DateOnlyIsoString;
  };
  claims: LoadStatusSubstate & {
    data: CheckoutClaim[];
  };
  borrowingHistory: LoadStatusSubstate & {
    data: BorrowingHistoryRecord[];
  };
  dependentCheckedOut: LoadStatusSubstate & {
    data: Checkout[];
  };
}

export const INITIAL_CHECKOUTS_STATE: CheckoutsState = {
  checkedOut: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
  nextCheckedOutDueDate: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    date: undefined
  },
  claims: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
  borrowingHistory: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
  dependentCheckedOut: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
  },
};

export const checkoutsState = createReducer(
  INITIAL_CHECKOUTS_STATE,
  on(CheckoutsActions.loadCheckedOut, (state) => ({
    ...state,
    checkedOut: {
      ...state.checkedOut,
      loadStatus: LOADING
    }
  })),
  on(CheckoutsActions.loadCheckedOutSuccess, (state, {listData: {data}}) => ({
    ...state,
    checkedOut: {
      ...state.checkedOut,
      loadStatus: LOADED,
      data
    }
  })),
  on(CheckoutsActions.loadCheckedOutFailure, state => ({
    ...state,
    checkedOut: {
      ...INITIAL_CHECKOUTS_STATE.checkedOut,
      loadStatus: FAILED,
    }
  })),

  on(CheckoutsActions.loadNextCheckedOutDueDate, state => ({
    ...state,
    nextCheckedOutDueDate: {
      ...state.nextCheckedOutDueDate,
      loadStatus: LOADING
    }
  })),
  on(CheckoutsActions.loadNextCheckedOutDueDateSuccess, (state, {date}) => ({
    ...state,
    nextCheckedOutDueDate: {
      ...state.nextCheckedOutDueDate,
      loadStatus: LOADED,
      date
    }
  })),
  on(CheckoutsActions.loadNextCheckedOutDueDateFailure, state => ({
    ...state,
    nextCheckedOutDueDate: {
      ...INITIAL_CHECKOUTS_STATE.nextCheckedOutDueDate,
      loadStatus: FAILED
    }
  })),

  on(CheckoutsActions.loadCheckoutClaims, (state) => ({
    ...state,
    claims: {
      ...state.claims,
      loadStatus: LOADING
    }
  })),
  on(CheckoutsActions.loadCheckoutClaimsSuccess, (state, {listData: {data}}) => ({
    ...state,
    claims: {
      ...state.claims,
      loadStatus: LOADED,
      data,
    }
  })),
  on(CheckoutsActions.loadCheckoutClaimsFailure, state => ({
    ...state,
    claims: {
      ...INITIAL_CHECKOUTS_STATE.claims,
      loadStatus: FAILED,
    }
  })),
  on(CheckoutsActions.loadBorrowingHistory, (state) => ({
    ...state,
    borrowingHistory: {
      ...state.borrowingHistory,
      loadStatus: LOADING
    }
  })),
  on(CheckoutsActions.loadBorrowingHistorySuccess, (state, {listData: {data}}) => ({
    ...state,
    borrowingHistory: {
      ...state.borrowingHistory,
      loadStatus: LOADED,
      data,
    }
  })),
  on(CheckoutsActions.loadBorrowingHistoryFailure, state => ({
    ...state,
    borrowingHistory: {
      ...INITIAL_CHECKOUTS_STATE.borrowingHistory,
      loadStatus: FAILED,
    }
  })),

  // Dependent
  on(PatronActions.loadDependentCheckouts, (state) => ({
    ...state,
    dependentCheckedOut: {
      ...state.dependentCheckedOut,
      loadStatus: LOADING
    }
  })),
  on(PatronActions.loadDependentCheckoutsSuccess, (state, {listData: {data}}) => ({
    ...state,
    dependentCheckedOut: {
      ...state.dependentCheckedOut,
      loadStatus: LOADED,
      data
    }
  })),
  on(PatronActions.loadDependentCheckoutsFailure, state => ({
    ...state,
    dependentCheckedOut: {
      ...INITIAL_CHECKOUTS_STATE.dependentCheckedOut,
      loadStatus: FAILED
    }
  })),
);
